import Link from 'components/Link'
import React from 'react'
import { Wrapper } from '../Wrapper'
import {
    Websites,
    PropertyManagement,
    API,
    AppLibrary,
    DataManagement,
    EventPipelines,
    RealestateMarketing,
    TransactionManagement,
    MobileApps,
    StakeholderManagement,
    Integrations,
    Projects,
    RealestateCrm,
    UserPermissions,
    Notifications,
    Listingshub,
} from 'components/ProductIcons'
import {
    HowiCloudReadyWorks,
    IdentifyUsers,
    Migrate,
    JSSnippet,
    Privacy,
    Quickstart,
    SDK,
    Tutorials,
    Webhooks,
} from 'components/NotProductIcons'

interface IFeature {
    title: string
    icon: React.ReactNode
    url: string
}

interface IColumn {
    title: string
    section: IFeature[]
    className?: string
}

const learn: IFeature[] = [
    { title: 'mobile apps', icon: <Quickstart />, url: '/tutorials' },
    { title: 'How to ?', icon: <JSSnippet />, url: '/tutorials' },
    { title: 'websites', icon: <EventPipelines />, url: '/tutorials' },
    { title: 'Academy', icon: <EventPipelines />, url: '/academy' },
    { title: 'Privacy', icon: <Privacy />, url: '/docs/privacy' },
]

const products: IFeature[] = [
    { title: 'Property management', icon: <PropertyManagement />, url: '/docs/property-management' },
    { title: 'Real estate crm', icon: <RealestateCrm />, url: '/docs/real-estate-crm' },
    { title: 'Real estate marketing', icon: <RealestateMarketing />, url: '/docs/real-estate-marketing' },
    { title: 'Mobile apps', icon: <MobileApps />, url: '/docs/real-estate-mobile-apps' },
    { title: 'Transaction management', icon: <TransactionManagement />, url: '/docs/transaction-management' },
    { title: 'Websites', icon: <Websites />, url: '/docs/websites' },
    { title: 'Analytics', icon: <Projects />, url: '/docs/analytics' },
    { title: 'Listing hub', icon: <Listingshub />, url: '/docs/listings-hub' },
]

const developer: IFeature[] = [
    { title: 'Tutorials', icon: <Tutorials />, url: '/tutorials' },
    { title: 'Integrations', icon: <Integrations />, url: '/docs/integrations' },
    { title: 'Dashboards', icon: <Notifications />, url: '/dashboards' },
    { title: 'API', icon: <API />, url: '/docs/api' },
    // { title: 'Webhooks', icon: <Webhooks />, url: '/docs/integrate/webhooks/message-formatting' },
    // { title: 'How iCloudReady works', icon: <HowiCloudReadyWorks />, url: '/docs/how-icloudready-works' },
    // { title: 'Migrate to iCloudReady', icon: <Migrate />, url: '/docs/migrate/ingest-historic-data' },
]

const categories: IColumn[] = [
    {
        title: 'Products Docs',
        section: products,
        className: '',
    },
    {
        title: 'Integrations & Marketplace',
        section: developer,
        className: '',
    },
    {
        title: 'Learn',
        section: learn,
        className: '',
    },
]

const Section = ({ title, section, className = '' }: IColumn) => {
    return (
        <ul className={`m-0 list-none space-y-2 p-0 ${className}`}>
            <h5 className="m-0 border-b border-dashed border-gray-accent-light pb-1 text-[15px] font-semibold opacity-40">
                {title}
            </h5>
            <ul className="m-0 grid list-none grid-cols-3 gap-2 p-0 dark:text-primary-dark md:grid-cols-7">
                {section.map(({ title, icon, url }, index) => {
                    return (
                        <li key={index} className="w-[6.5rem]">
                            <Link
                                to={url}
                                className="relative flex h-full flex-col items-center gap-2 rounded p-2 text-center text-[14px] font-semibold leading-tight hover:scale-[1.02] hover:bg-gray-accent-light/50 active:top-[1px] active:scale-[1] dark:hover:bg-gray-accent-light/25"
                            >
                                <div className="flex h-6 w-6 items-center justify-center">{icon}</div>
                                <span>{title}</span>
                            </Link>
                        </li>
                    )
                })}
            </ul>
        </ul>
    )
}

export default function Docs({ referenceElement }: { referenceElement: HTMLDivElement }) {
    return (
        <Wrapper referenceElement={referenceElement} placement="bottom-start">
            <div className="space-y-4 rounded-md px-8 py-6">
                <h3 className="mb-4 text-lg font-bold text-primary dark:text-primary-dark">
                    <Link to="/docs" className="hover:text-red">
                        Docs
                    </Link>
                </h3>
                {categories.map((section, index) => {
                    return <Section key={index} {...section} />
                })}
            </div>
        </Wrapper>
    )
}
